var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Masters_qualification",
    "data-name": "Masters qualification",
    transform: "translate(-718 -502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 30,
    height: 30,
    transform: "translate(718 502)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "graduation",
    transform: "translate(724 507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M19.773,5.213h9.82v-4h.99V4.688H31.8V1.212h1.071V0H16.5V1.212h3.273Zm0,0",
    transform: "translate(-15.833)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M127.5,160.235a3.7,3.7,0,1,0,7.4,0V159h-7.4Zm0,0",
    transform: "translate(-122.347 -152.574)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M13.693,285.18,8.85,291.729,4.007,285.18A5.343,5.343,0,0,0,0,290.347v4H17.7v-4a5.343,5.343,0,0,0-4.007-5.167Zm0,0",
    transform: "translate(0 -273.655)",
    fill: "#3f2765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M140.335,281.047H140.1a4.9,4.9,0,0,1-6.454,0h-.232l3.459,4.677Zm0,0",
    transform: "translate(-128.026 -269.689)",
    fill: "#3f2765"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasters);
export default __webpack_public_path__ + "static/media/masters.fa07306b954187ce1c5350a0e3b4a7ec.svg";
export { ForwardRef as ReactComponent };